"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_output.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function getChromaKeyLabel(addon, fallback) {
  var _ref = addon || {},
      value = _ref.value;

  return value ? 'YES' : fallback;
}

function renderCaption(_ref2) {
  var captionValue = _ref2.captionValue,
      type = _ref2.type,
      language = _ref2.language;
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "video-summary-output__extras__caption",
      key: "".concat(type, "-").concat(language)
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
      name: captionValue.prefix,
      size: 20
    }), /*#__PURE__*/_react.default.createElement("p", null, "".concat(captionValue.label, " (").concat(type, ")")))
  );
}

function Output(_ref3) {
  var isMaster = _ref3.isMaster,
      aspectRatio = _ref3.aspectRatio,
      title = _ref3.title,
      versions = _ref3.versions,
      getAddonLabel = _ref3.getAddonLabel,
      getCaptions = _ref3.getCaptions,
      ASPECT_RATIOS = _ref3.ASPECT_RATIOS,
      DURATIONS = _ref3.DURATIONS,
      RUSH_EDIT = _ref3.RUSH_EDIT;
  var appliedAddons = versions[0].appliedAddons;
  var durationValue = appliedAddons.DURATION,
      chromaKeyValue = appliedAddons.CHROMA_KEY,
      rushEditValue = appliedAddons.RUSH_EDIT;
  var captions = getCaptions(appliedAddons);
  var matchedAspectRatio = ASPECT_RATIOS.find(function (ratio) {
    return ratio.value === aspectRatio;
  }) || ASPECT_RATIOS[0];
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "video-summary-output"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "video-summary-output__header"
    }, isMaster ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
      name: "master",
      color: "dandelion",
      size: 20
    }) : null, /*#__PURE__*/_react.default.createElement("p", null, title)), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-summary-output__details"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "video-summary-output__details__row"
    }, /*#__PURE__*/_react.default.createElement("p", null, "OUTPUT"), /*#__PURE__*/_react.default.createElement("p", null, matchedAspectRatio.label)), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-summary-output__details__row"
    }, /*#__PURE__*/_react.default.createElement("p", null, "DURATION"), /*#__PURE__*/_react.default.createElement("p", null, getAddonLabel(DURATIONS, durationValue).label)), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-summary-output__details__row"
    }, /*#__PURE__*/_react.default.createElement("p", null, "CHROMA KEY"), /*#__PURE__*/_react.default.createElement("p", null, getChromaKeyLabel(chromaKeyValue, 'NO'))), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-summary-output__details__row"
    }, /*#__PURE__*/_react.default.createElement("p", null, "V1 RUSH EDIT"), /*#__PURE__*/_react.default.createElement("p", null, getAddonLabel(RUSH_EDIT, rushEditValue, 'N/A').label))), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-summary-output__extras"
    }, /*#__PURE__*/_react.default.createElement("p", null, "EXTRAS"), captions && captions.length ? captions.map(renderCaption) : /*#__PURE__*/_react.default.createElement("p", null, "No extra add-ons have been requested for this output")))
  );
}

var _default = (0, _react.memo)(Output);

exports.default = _default;